<div class="result-exam">
    <div>
        <!-- <mat-label class="font-small">
            نتایج بر اساس اولین نوبت حل این آزمون است.
        </mat-label> -->
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="1rem" class="full-w">
            <div fxLayout="row" fxLayoutAlign="center center" class="full-w res-parent">
                <div class="back-to-exam" (click)="onGoToExams()">
                    <img class="icon" src="../../../../../../../assets/icons/Times.svg" alt="" loading="lazy" />
                </div>
                <div class="header font-small font-white" fxLayout="column" fxLayoutAlign="center center">کارنامه
                    {{title}}
                </div>

            </div>
            <!-- Top User Info -->
            <div fxLayout="row" fxLayoutAlign="space-between center" class="user-info">
                <div class="leftSection">
                    <div class="rate">
                        <!-- <i class='bx bx-medal'></i> -->
                        <img src="../../../../../../../assets/icons/Medal.svg" alt=""
                            class="icon-height-1 icon-width-1">
                        <h3>رتبه</h3>
                        <span>: </span>
                        <span> {{studentModel?.rank }} </span>

                    </div>
                </div>
                <div class="rightSection">
                    <img class="studentImage"
                        [src]="studentModel?.student_profile_pic ? studentModel?.student_profile_pic :'../../../../../../../assets/new/avatar-def.png'"
                        alt="" loading="lazy">

                    <div class="text">
                        <!-- {{studentModel?.grade_title}} -->
                        <h2>{{studentModel?.student_fullname}}</h2>
                        <p>{{studentModel?.exam_date | dateTime}} </p>
                    </div>
                </div>
            </div>
            <div class="percentage-wrapper">
                <div *ngFor="let item of studentModel?.categories; index as i" class="percentage-item">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="leasson-title">
                            {{item.title}}
                        </div>
                        <div class="leasson-percentage">
                            <span class="percentage"> {{item?.percent}}</span>
                            <span>%</span>
                        </div>
                    </div>
                    <div class="full-w">

                        <progress-bar [progress]="item?.percent" [color]="calculateColor(item?.percent)">
                        </progress-bar>
                    </div>
                </div>

            </div>

            <div fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="1rem" class="bottom-progress">
                <!-- <div class="full-w" fxLayout="row wrap" fxLayoutAlign="space-between  center" dir="rtl">
                    <div *ngFor="let item of studentModel?.categories; index as i" fxFlex="44" fxLayout="row"
                        fxLayoutAlign="space-between center" class="result-progress">
                        <div [ngClass]="calculateClass(i, item.percent)" class="percentage"></div>
                      
                        <mat-label class="fontn-small">{{item.title}}</mat-label>
                    </div>
                </div> -->
                <div fxLayout="row" fxLayoutAlign="space-between center" class="full-w par">
                    <!-- <button fxFlex="44"  class="result-btn"
                        (click)="showRanking()">
                        <mat-label class="font-small font-white">نفرات برتر</mat-label>
                    </button> -->
                    <app-tik-btn (click)="showRanking()" [btnClass]="'btn-blue'" [btnLoading]="false"
                        [btnText]="'نفرات برتر'" fxFlex="44"></app-tik-btn>
                    <!-- <button *ngIf="!resultReady" fxFlex="44" mat-raised-button class="result-btn-gray" disabled
                        fxLayout="column" fxLayoutAlign="flex-start center">
                        <div fxLayout="row" fxLayoutAlign="center center" class="result-btn">
                            <mat-label class="font-xsmall font-gray">نفرات برتر</mat-label>
                        </div>
                        <div class="res-btn-top">
                            <mat-label class="font-xsmall font-gray">{{studentModel?.start_time | timeAfter}}
                            </mat-label>
                        </div>
                    </button> -->
                    <!-- <button fxFlex="44" mat-raised-button class="result-btn" (click)="gotoResult()">
                        <mat-label class="font-small font-white">پاسخنامه</mat-label>
                    </button> -->
                    <app-tik-btn (click)="gotoResult()" [btnClass]="'btn-blue'" [btnLoading]="false"
                        [btnText]="'پاسخنامه'" fxFlex="44"></app-tik-btn>
                    <!-- <button *ngIf="!resultReady" fxFlex="44" mat-raised-button class="result-btn-gray"
                        (click)="gotoHome()" fxLayout="column" fxLayoutAlign="flex-start center">
                        <div fxLayout="row" fxLayoutAlign="center center" class="result-btn">
                            <mat-label class="font-xsmall font-gray">پاسخنامه</mat-label>
                        </div>
                        <div class="res-btn-top">
                            <mat-label class="font-xsmall font-gray">{{studentModel?.start_time | timeAfter}}
                            </mat-label>
                        </div>
                    </button> -->
                    <!-- <button (click)="reloadExam()" fxFlex="100" mat-raised-button class="retry-btn">
                        <mat-label class="font-small font-white"> حل دوباره آزمون</mat-label>
                    </button> -->
                    <div class="divider1"></div>
                    <app-tik-btn (click)="reloadExam()" [btnClass]="'btn-green'" [btnLoading]="false"
                        [btnText]="'حل دوباره آزمون'" fxFlex="100"></app-tik-btn>
                </div>
                <!-- <div *ngIf="banners.length > 0">
                    <img [src]="banners[0].image_url">
                </div> -->
            </div>
        </div>
    </div>
    <div class="divider1"></div>
</div>
<!-- studentModel.results.length > 3 ? 33 : 100/studentModel.results.length -->